import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import {
  Alert,
  Box,
  Checkbox,
  EnumHelperText,
  HelperText,
  Label,
  SpinnerLoader,
  Typography,
} from 'shared/ui'
import type { IAlert } from 'shared/ui/Alert/types'
import { MessageField } from 'widgets/MessageField'
import { useChatbotContext } from 'pages/chatbot/context'
import styles from './styles.module.scss'

type IStepObjectiveContentProps = {
  type: 'default' | 'booking'
  errorAlert?: IAlert
  error?: string
}

export const StepObjectiveContent = observer(
  ({ errorAlert, error, type }: IStepObjectiveContentProps) => {
    const { fieldsControl, model, stepObjectiveStore } = useChatbotContext()
    const { messageFieldStore, loading } = stepObjectiveStore
    const { fields, settings } = model

    useEffect(() => {
      fieldsControl.init()

      if (type === 'booking') {
        stepObjectiveStore.initBooking()
      }

      if (type === 'default') {
        stepObjectiveStore.initDefault()
      }

      return () => {
        stepObjectiveStore.dispose()
      }
    }, [])

    if (loading) return <SpinnerLoader ariaLabel={'StepObjectiveContent'} />

    return (
      <>
        <Label
          label={{
            text: 'Data collection instructions',
          }}
          questionTooltipProps={{
            type: 'description',
            label: 'Write instructions for the Agent to collect data',
            desc: 'Use merge fields to access contact data',
          }}
        />

        <MessageField messageFieldStore={messageFieldStore} />

        {error && (
          <div className={styles.error}>
            <HelperText icon={'alertTriangleSmall'} variant={EnumHelperText.Error} text={error} />
          </div>
        )}
        {errorAlert && <Alert className={styles.errorAlert} item={errorAlert} />}

        {fields.list.length > 0 && (
          <Box display='flex' alignItems='center' marginTop={'20px'}>
            <Checkbox
              checked={settings.skipKnownFields}
              onChange={() => {
                settings.setSkipKnownFields(!settings.skipKnownFields)
              }}
              style={{ marginRight: 8 }}
              size={16}
            />
            <Typography variant='body-sm-regular' ariaLabel='skipQuestions' color='tertiary'>
              Skip questions if data is already known
            </Typography>
          </Box>
        )}
      </>
    )
  }
)
